// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/KioskOrderModal/KioslOrderForm.css
// module id = 1973
// module chunks = 0